import { render, staticRenderFns } from "./courierCompanyList.vue?vue&type=template&id=29ceec62&scoped=true&"
import script from "./courierCompanyList.vue?vue&type=script&lang=js&"
export * from "./courierCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ceec62",
  null
  
)

export default component.exports